module.exports = __webpack_public_path__ + "media/Icons/PaymentFailedIcon-d586edb5.png";